import { ResidentProvider } from "app/features/residents/provider/ResidentProvider";
import AddResidentScreen from "app/screens/residents/AddResidentScreen";

export default function AddResident() {
  return (
    <ResidentProvider>
      <AddResidentScreen />
    </ResidentProvider>
  );
}
